import { UserMessage } from '../../../types/UserMessage';
import { UserStatus } from '../../../types/UserStatus';
import { DeleteConfirmPopup } from '../../common/DeleteConfirmPopup/DeleteConfirmPopup';
import { translate } from '../../common/helpers/translate.helper';
import { useUserManagementUpdate } from '../list/hooks/useUserManagementUpdate';

interface DeactivateMemberModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    user: UserMessage;
}

export const DeactivateMemberModal = ({ isOpen, onDismiss, user }: DeactivateMemberModalProps) => {
    const userManagementUpdateMutation = useUserManagementUpdate();

    const handleDeactivate = async () => {
        if (!user) return;

        try {
            await userManagementUpdateMutation.mutateAsync({
                userId: user.id,
                userMessage: {
                    ...user,
                    status: UserStatus.INACTIVE,
                },
            });
        } finally {
            onDismiss();
        }
    };

    return (
        <DeleteConfirmPopup
            isOpen={isOpen}
            onSubmit={handleDeactivate}
            onDismiss={onDismiss}
            headline={translate('user.deactivateMemberHeadline')}
            text={translate('user.deactivateMemberConfirm')}
            itemToDelete={user?.email}
            deleteButtonText={translate('user.setInactiveButton')}
            isSubmitting={userManagementUpdateMutation.isPending}
        />
    );
};
